import {
  ENTITY_SUITABILITY_DESER,
  type EntitySuitability,
} from "../../tastyworks/entity-suitability"
import type HttpClient from "../../tastyworks/http"

export class EntitySuitabilityService {
  constructor(
    private readonly customerMeClient: HttpClient,
    private readonly baseHttpClient: HttpClient
  ) {}

  readonly update = async (entityId: string, suitability: EntitySuitability) =>
    this.customerMeClient.update(
      suitability,
      ENTITY_SUITABILITY_DESER.serialize,
      ENTITY_SUITABILITY_DESER.update,
      "/entities/:entityId/suitability",
      { entityId }
    )

  readonly updateForAccountOpening = async (
    entityId: string,
    suitability: EntitySuitability
  ) =>
    this.baseHttpClient.update(
      suitability,
      ENTITY_SUITABILITY_DESER.serialize,
      ENTITY_SUITABILITY_DESER.update,
      "/entities/:entityId/suitability",
      { entityId }
    )

  readonly createForAccountOpening = async (
    entityId: string,
    suitability: EntitySuitability
  ) =>
    this.baseHttpClient.create(
      suitability,
      ENTITY_SUITABILITY_DESER.serialize,
      ENTITY_SUITABILITY_DESER.update,
      "/entities/:entityId/suitability",
      { entityId }
    )
}
